import React from 'react';
import { defineMessages, FormattedMessage, FormattedNumber } from 'react-intl';

const messages = defineMessages({
  noteFromBuyer: {
    description: 'orderNotes.type.noteFromBuyer',
    defaultMessage: '{ noteCount, plural, one {Note} other {Notes}} From Buyer',
    id: 'D7mKWl',
  },
  noteToBuyer: {
    description: 'orderNotes.type.noteToBuyer',
    defaultMessage: '{noteCount, plural, one {Note} other {Notes}} To Buyer',
    id: '8yZx3e',
  },
  giftNote: {
    description: 'orderNotes.type.giftNote',
    defaultMessage: 'Gift {noteCount, plural, one {Note} other {Notes}}',
    id: 'EMEP3K',
  },
  internalNote: {
    description: 'orderNotes.type.internalNote',
    defaultMessage: 'Internal {noteCount, plural, one {Note} other {Notes}}',
    id: 'RaA8wg',
  },
  customFieldOne: {
    description: 'orderNotes.type.customFieldOne',
    defaultMessage: 'Custom Field 1',
    id: 'pPhUrR',
  },
  customFieldTwo: {
    description: 'orderNotes.type.customFieldTwo',
    defaultMessage: 'Custom Field 2',
    id: 'Q9r+t+',
  },
  customFieldThree: {
    description: 'orderNotes.type.customFieldThree',
    defaultMessage: 'Custom Field 3',
    id: 'PFPi5R',
  },
  unknownNoteType: {
    description: 'orderNotes.type.unknown',
    defaultMessage: '{noteCount, plural, one {Note} other {Notes}}',
    id: '2LP6N2',
  },
  gift: {
    description: 'orderNotes.type.gift',
    defaultMessage: 'Gift',
    id: '5vkxQ8',
  },
  notes: {
    description: 'orderNotes.noteCounts',
    defaultMessage: '{noteCount, plural, one {# Note} other {# Notes}}',
    id: '+k4OyJ',
  },
  notesAndGift: {
    description: 'orderNotes.noteCountsAndGift',
    defaultMessage: '{noteCount, plural, one {# Note} other {# Notes}}, Gift',
    id: 'mlRvU1',
  },
  noteCountAndGiftLabel: {
    defaultMessage: '{noteCount}, Gift',
    description: 'Label to indicate the number of notes and if there is a gift note',
    id: '/UyUg4',
  },
});

export const CustomFieldIds = {
  CustomFieldOne: 'CustomFieldOne',
  CustomFieldTwo: 'CustomFieldTwo',
  CustomFieldThree: 'CustomFieldThree',
};

export const NOTE_TYPES = {
  NotesFromBuyer: messages.noteFromBuyer,
  NotesToBuyer: messages.noteToBuyer,
  GiftNote: messages.giftNote,
  Internal: messages.internalNote,
  [CustomFieldIds.CustomFieldOne]: messages.customFieldOne,
  [CustomFieldIds.CustomFieldTwo]: messages.customFieldTwo,
  [CustomFieldIds.CustomFieldThree]: messages.customFieldThree,
};

export const getNoteType = (noteTypeId, noteCount) => {
  const noteTypeMessage = NOTE_TYPES[noteTypeId];
  if (noteTypeMessage) {
    return <FormattedMessage {...noteTypeMessage} values={{ noteCount }} />;
  }
  return <FormattedMessage {...messages.unknownNoteType} values={{ noteCount }} />;
};

export const isOrderNoteEditable = (noteType) => {
  return noteType !== 'NotesFromBuyer';
};

export const canAddNewNote = (noteType, notes) => {
  const currentTypes = [...new Set(notes.map((note) => note.type))];
  if (noteType !== 'Internal') {
    if (currentTypes.indexOf(noteType) > -1) {
      return false;
    }
  }
  return true;
};

export const getAllNoteTypes = (orderNotes = []) => {
  const noteCount = 1;
  return Object.keys(NOTE_TYPES).map((note) => ({
    id: note,
    message: <FormattedMessage {...NOTE_TYPES[note]} values={{ noteCount }} />,
    disabled: !canAddNewNote(note, orderNotes),
  }));
};

export const noteTypeIsInternal = (noteTypeId) => noteTypeId === 'Internal';

export const hasGiftNote = (notes = []) => {
  const currentTypes = [...new Set(notes.map((note) => note.type))];
  return currentTypes.includes('GiftNote');
};

export const noteCountAndGiftText = (notes, hideNotesLabel = false) => {
  const filteredNotes = notes.filter((note) => note.body);
  const noteCount = filteredNotes.length;
  const hasGift = hasGiftNote(filteredNotes);

  const formattedNoteCount = <FormattedNumber value={noteCount} />;

  if (hasGift) {
    return hideNotesLabel ? (
      <FormattedMessage {...messages.noteCountAndGiftLabel} values={{ noteCount: formattedNoteCount }} />
    ) : (
      <FormattedMessage {...messages.notesAndGift} values={{ noteCount }} />
    );
  }

  return hideNotesLabel ? formattedNoteCount : <FormattedMessage {...messages.notes} values={{ noteCount }} />;
};
